import { render } from "./OAuthLoginPanel.vue?vue&type=template&id=4a28019e"
import script from "./OAuthLoginPanel.vue?vue&type=script&lang=js"
export * from "./OAuthLoginPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__